export default __webpack_public_path__ + "static/media/2.9eb8e338.jpg";